export default class UniqueSystemIngredientName {
  constructor($q, SystemIngredientsService) {
    'ngInject';

    Object.assign(this, {
      $q,
      SystemIngredientsService
    });

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    let ingredientId = null;

    if (attrs.ingredientId) {
      ingredientId = attrs.ingredientId;
    }

    // Async validator requires resolve or reject to set validity
    ctrl.$asyncValidators.uniqueSystemIngredientName = (ingredientName) => {
      const defer = this.$q.defer();

      this.SystemIngredientsService.isUniqueIngredientName(ingredientName, ingredientId)
        .then((r) => {
          if (r.data) {
            defer.resolve();
          }

          defer.reject();
        }).catch(() => defer.reject());

      return defer.promise;
    };
  }

  static directiveFactory($q, SystemIngredientsService) {
    'ngInject';

    return new UniqueSystemIngredientName($q, SystemIngredientsService);
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/unique-system-ingredient-name.js